import api from "../api";

export const useDeleteProperty = (id) =>
    api.delete(`/property/${id}`, id).then((res) => res.data);
